<template>
  <div class="storys">
    <div class="tart">
      <h2>Interjúk</h2>
      <ul class="links">
        <li>
          <div class="title">
            D. Tóth Kriszta
          </div>
          <div class="cikk">
            <router-link to="/a-tudatos-autohasznalatrol">
              <img
                src="../assets/img/arrow.svg"
                alt="->"
              >
              <span>A tudatos autóhasználatról</span>
            </router-link>
          </div>
        </li>
        <li>
          <div class="title">
            Győrfi Pál
          </div>
          <div class="cikk">
            <router-link to="/az-innovacio-iranti-vonzalomrol">
              <img
                src="../assets/img/arrow.svg"
                alt="->"
              >
              <span>Az innováció iránti vonzalomról</span>
            </router-link>
          </div>
        </li>
        <li>
          <div class="title">
            Mercedes EQC
          </div>
          <div class="cikk">
            <router-link to="/mercedes-eqc">
              <img
                src="../assets/img/arrow.svg"
                alt="->"
              >
              <span>A modellről</span>
            </router-link>
          </div>
        </li>
      </ul>
    </div>
    <div class="benz">
      <div class="image">
        <img
          src="../assets/img/eqc-story.jpg"
          alt="Mercedes EQC"
        >
      </div>
      <h2>Mercedes EQC</h2>
      <div class="text">
        Az EQC megérkezéséig exkluzív bepillantást biztosítunk,
        és előzetes információkkal látunk el az új EQC-re vonatkozóan, hogy
        felkészülten fogadhasd első teljesen elektromos modellünket. Regisztrálj most!
      </div>
      <a
        class="regisztracio"
        href="http://bit.ly/2lViiXR"
      ><img
          class="arrowright"
          src="../assets/img/arrow-right-link.svg"
          alt=">"
        > Regisztráció</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StorysComponent',
  props: {

  },
  methods: {

  },
};
</script>

<style scoped lang="css">
.storys {
  display: grid;
  display: -ms-grid;
  grid-template-columns: 1fr 1fr;
  -ms-grid-columns: 1fr 1fr;
}
.benz {
  display: grid;
  display: -ms-grid;
  grid-template-columns: 60px 1fr 1fr 60px;
  -ms-grid-columns: 60px 1fr 1fr 60px;
}
.tart {
  display: grid;
  display: -ms-grid;
  grid-column: 1/2;
  -ms-grid-column: 1;
  background-color: #fff;
  color: #151726;
  padding: 70px 0 70px 0;
  grid-template-columns: 60px auto 60px;
  -ms-grid-columns: 60px auto 60px;
  border-top: 1px solid #151726;
}
.benz {
  grid-column: 2/3;
  -ms-grid-column: 2;
  background-color: #151726;
  grid-template-rows: 50px auto auto auto 50px;
  -ms-grid-rows: 50px auto auto auto 50px;
}
.tart h2 {
  grid-column: 2/4;
  -ms-grid-column: 2;
  -ms-grid-column-span: 2;
  font-size: 45px;
  margin-block-start: 0;
  margin-block-end: 0;
}
.tart h2,
.benz h2 {
  font-family: "Old Standard TT", serif;
  margin: 0;
}
.benz h2 {
  grid-column: 1/4;
  -ms-grid-column: 1;
  -ms-grid-column-span: 3;
  font-size: 77px;
  justify-self: end;
  grid-row: 2/3;
  -ms-grid-row: 2;
  text-align: right;
}
.links {
  grid-column: 2/4;
  -ms-grid-column: 2;
  -ms-grid-column-span: 2;
  list-style: none;
  margin-block-start: 0;
  margin-block-end: 0;
  padding-inline-start: 0;
}
.links li {
  margin-top: 45px;
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
}
li .title {
  text-transform: uppercase;
  font-size: 22px;
  flex-basis: 230px;
}
li:nth-child(3) .title {
  color: #00a3f8;
}
.benz .text {
  margin: 30px 0;
  padding: 0 20px;
  grid-column: 3/4;
  -ms-grid-column: 3;
  font-size: 16px;
  line-height: 1.5;
  grid-row: 3/4;
  -ms-grid-row: 4;
}
.benz .regisztracio {
  text-decoration: none;
  display: block;
  text-transform: uppercase;
  font-size: 16px;
  height: 16px;
  background-color: #00adef;
  padding: 12px 15px;
  color: #fff;
  grid-column: 3/4;
  -ms-grid-column: 3;
  margin: 0 20px;
  border-radius: 1px;
  grid-row: 4/5;
  -ms-grid-row: 5;
}
.arrowright {
  height: 10px;
  margin-right: 15px;
  transition: all 1s;
}
.benz .regisztracio:hover .arrowright {
  margin-right: 20px;
}
.benz .image {
  background-image: url("../assets/img/eqc-story.jpg");
  background-size: cover;
  grid-column: 1/3;
  -ms-grid-column: 1;
  -ms-grid-column-span: 2;
  grid-row: 1/6;
  -ms-grid-row: 1;
  -ms-grid-row-span: 5;
  background-position: center right;
  background-repeat: no-repeat;
}
.benz .image img {
  display: none;
}
.cikk {
  font-size: 18px;
}
.cikk a {
  text-decoration: none;
  color: #151726;
  display: flex;
  align-items: center;
  white-space: nowrap;
}
.cikk img {
  height: 15px;
  margin-right: 15px;
}
.cikk a:hover span {
  text-decoration: underline;
}
@media screen and (max-width: 1280px) {
  .storys {
    grid-template-columns: 500px 1fr;
    -ms-grid-columns: 500px 1fr;
  }
}
@media screen and (max-width: 1080px) {
  .storys {
    grid-template-columns: 380px 1fr;
    -ms-grid-columns: 380px 1fr;
  }
  li .title {
    margin-bottom: 5px;
  }
}
@media screen and (max-width: 900px) {
  .storys {
    grid-template-columns: 1fr;
    -ms-grid-columns: 1fr;
    grid-template-rows: auto auto;
    -ms-grid-rows: auto auto;
  }
  .tart {
    grid-column: 1/2;
    -ms-grid-column: 1;
    grid-row: 1/2;
    -ms-grid-row: 1;
  }
  .benz {
    grid-column: 1/2;
    -ms-grid-column: 1;
    grid-row: 2/3;
    -ms-grid-row: 2;
  }
  .tart,
  .benz {
    grid-template-columns: 30px 1fr 1fr 30px;
    -ms-grid-columns: 30px 1fr 1fr 30px;
  }
  li .title {
    flex-basis: 230px;
  }
  .tart {
    padding: 40px 0 70px 0;
  }
}
@media screen and (max-width: 767px) {
  .benz h2 {
    font-size: 45px;
  }
  li .title {
    flex-basis: 100%;
  }
}
@media screen and (max-width: 540px) {
  .benz {
    grid-template-rows: auto auto auto auto 50px;
    -ms-grid-rows: auto auto auto auto 50px;
  }
  .benz .image {
    background-image: none;
    grid-column: 1/5;
    -ms-grid-column: 1;
    -ms-grid-column-span: 4;
    grid-row: 1/2;
    -ms-grid-row: 1;
    -ms-grid-row-span: 1;
  }
  .benz .image img {
    display: block;
    width: 100%;
  }
  .benz h2 {
    grid-column: 2/4;
    -ms-grid-column: 2;
    -ms-grid-column-span: 2;
    justify-self: left;
    grid-row: 1/3;
    -ms-grid-row: 1;
    -ms-grid-row-span: 2;
    text-align: left;
    align-self: end;
    line-height: 1;
  }
  .benz .text,
  .benz .regisztracio {
    grid-column: 2/4;
    -ms-grid-column: 2;
    -ms-grid-column-span: 2;
  }
  .benz .text {
    padding: 0;
  }
  .benz .regisztracio {
    margin: 0;
  }
  .cikk img {
    height: 10px;
    margin-right: 10px;
  }
}
@media screen and (max-width: 400px) {
  .cikk a {
    white-space: normal;
  }
}
</style>
